import type {
  SchemaBuilderExcludedFieldTypesConfig,
  SchemaBuilderPickableFieldTypeConfig,
} from "./schema-builder-field-type.type";

export const SCHEMA_BUILDER_FIELD_TYPE_PICKABLE: SchemaBuilderPickableFieldTypeConfig =
  {
    // Severity section fields = not pickable
    defects: false,
    inspectedComponent: false,
    materials: false,
    severities: false,

    // Other fields = pickable
    label: true,
    number: true,
    text: true,
    textArea: true,
    checkbox: true,
    select: true,
    expression: true,
    assetUnlockToggler: true,
  };

export const SCHEMA_BUILDER_EXCLUDED_FIELD_TYPES: SchemaBuilderExcludedFieldTypesConfig =
  {
    intervention_template: [],
    technical_form: [
      "assetUnlockToggler",
      "inspectedComponent",
      "materials",
      "defects",
      "severities",
    ],
  };
